
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing-control",
      function () {
        return require("private-next-pages/landing-control.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing-control"])
      });
    }
  